import { render } from "./ImportDatabase.vue?vue&type=template&id=bcdd840e"
import script from "./ImportDatabase.vue?vue&type=script&lang=js"
export * from "./ImportDatabase.vue?vue&type=script&lang=js"

import "./ImportDatabase.vue?vue&type=style&index=0&id=bcdd840e&lang=scss"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__